import { PenTool, RotateCcw, Check } from 'lucide-react';
import SignatureCanvas from 'react-signature-canvas';

/**
 * Signature Modal — captures customer or inspector signatures on a
 * react-signature-canvas. Pure presentation; parent owns the ref + handlers.
 *
 * Extracted from CleaningInspection.js as part of the giant-component
 * refactor (Feb 2026). Behavior is byte-for-byte equivalent.
 */
const SignatureModal = ({
  open,
  signatureType,
  signatureRef,
  onClear,
  onCancel,
  onSave,
}) => {
  if (!open) return null;
  const isCustomer = signatureType === 'customer';
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000,
      }}
      data-testid="inspection-signature-modal"
    >
      <div style={{ background: 'white', borderRadius: '16px', padding: '24px', maxWidth: '500px', width: '95%' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              width: '48px',
              height: '48px',
              background: isCustomer
                ? 'linear-gradient(135deg, #dbeafe 0%, #93c5fd 100%)'
                : 'linear-gradient(135deg, #e0f2ff 0%, #93c5fd 100%)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <PenTool size={24} color={isCustomer ? '#3b82f6' : '#0073ea'} />
          </div>
          <div>
            <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#1f2937' }}>
              {isCustomer ? 'Customer Signature' : 'Inspector Signature'}
            </h3>
            <p style={{ fontSize: '13px', color: '#6b7280' }}>
              {isCustomer
                ? 'Please sign to confirm inspection completion'
                : 'Sign to verify inspection was performed'}
            </p>
          </div>
        </div>

        <div style={{ border: '2px dashed #e5e7eb', borderRadius: '12px', marginBottom: '16px', background: '#fafafa' }}>
          <SignatureCanvas
            ref={signatureRef}
            canvasProps={{
              width: 450,
              height: 200,
              style: { width: '100%', height: '200px', borderRadius: '10px' },
            }}
            backgroundColor="rgb(250, 250, 250)"
          />
        </div>

        <p style={{ fontSize: '12px', color: '#9ca3af', textAlign: 'center', marginBottom: '16px' }}>
          Draw your signature above using mouse or touch
        </p>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'space-between' }}>
          <button
            onClick={onClear}
            data-testid="clear-signature-button"
            style={{
              padding: '10px 20px',
              background: '#f3f4f6',
              color: '#374151',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            <RotateCcw size={16} /> Clear
          </button>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={onCancel}
              data-testid="cancel-signature-button"
              style={{
                padding: '10px 20px',
                background: '#f3f4f6',
                color: '#374151',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '500',
              }}
            >
              Cancel
            </button>
            <button
              onClick={onSave}
              data-testid="save-signature-button"
              style={{
                padding: '10px 20px',
                background: isCustomer ? '#3b82f6' : '#0073ea',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              }}
            >
              <Check size={16} /> Save Signature
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureModal;
